import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SdohPermissionsEnum } from '@app/core/constants/permissions.enum';
import { SecurityService } from '@mynexus/mynexus-ui-lib';

@Component({
  template: '',
  styleUrls: [],
  standalone: true,
})
export class HomePageComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly securityService = inject(SecurityService);

  public ngOnInit(): void {
    let url = this.securityService.hasAccess([SdohPermissionsEnum.PENDING_REFERRAL_READ])
      ? 'sdoh/pending-referrals'
      : 'sdoh/my-referrals';

    this.router.navigateByUrl(url);
  }
}
